@if (appState.isBlockingOverlay()) {
  <app-loading-overlay></app-loading-overlay>
}

@if (showLocationOverlay()) {
  <user-location
    appGlossScroll
    role="dialog"
    aria-modal="true"
    aria-labelledby="locationSelectionTitle"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    class="tw-fixed tw-inset-0 tw-z-[101] tw-flex tw-flex-col tw-items-center tw-justify-start tw-overflow-y-auto tw-bg-black/70 gs-dark"
  ></user-location>
}

<!-- appPrimaryNavArrowKeys: Right Arrow on a menu item enters the page, Left Arrow in the page
     returns to the active menu item (see the directive for the keys it leaves alone). -->
<div
  appPrimaryNavArrowKeys
  [attr.inert]="showLocationOverlay() ? '' : null"
  class="tw-flex tw-w-full tw-h-screen tw-overflow-hidden tw-bg-color-surface-page"
>
  @if (deviceDetector.isDesktop()) {
    <div appGlossScroll class="tw-h-full tw-w-[240px] tw-shrink-0 auto-hide-scrollbar sm:tw-hidden">
      <app-side-menu (openHelpBoxEvent)="openHelpBox()"></app-side-menu>
    </div>
  }
  <div
    appGlossScroll
    #scrollContainer
    id="page-scroll"
    cdkScrollable
    appElasticScroll
    appPullToRefresh
    [appPullToRefreshEnabled]="deviceDetector.isMobile()"
    [appPullToRefreshDisabled]="pullToRefreshDisabled()"
    class="tw-z-1 tw-flex tw-flex-col xs:tw-fixed xs:tw-left-0 xs:tw-right-0 tw-w-full tw-h-full auto-hide-scrollbar"
  >
    <div
      class="tw-flex tw-flex-col tw-h-full xs:tw-h-auto tw-w-full"
      [ngStyle]="{ 'min-height': 'fit-content' }"
    >
      <!-- The one side gutter for every page, 16px on phones and desktop alike (#6171): pages don't
           add their own. It's --page-gutter, so what bleeds into it (e.g. .gutter-bleed-column)
           follows it; a route with data: { fullBleed: true } sets it to 0 on phones. -->
      <main
        class="[--page-gutter:1rem] tw-px-[var(--page-gutter)] tw-py-4 xs:tw-pt-2 xs:tw-pb-0 tw-h-full tw-min-w-[344px]"
        [ngClass]="{ 'xs:[--page-gutter:0px]': fullBleed() }"
      >
        <div #pageTransition data-primary-content class="tw-h-full">
          <router-outlet (activate)="onRouterOutletActivate()"></router-outlet>
        </div>
        <div [style.height.px]="menuHeight"></div>
      </main>
    </div>
    @if (deviceDetector.isMobile()) {
      <div>
        <app-menu
          (openHelpBoxEvent)="openHelpBox()"
          (menuHeightEvent)="updateMenuHeight($event)"
        ></app-menu>
      </div>
    }
  </div>

  <!-- @if (appState.helpBox().isVisible) {
    <app-help-box class="tw-absolute tw-bottom-0 tw-top-0 tw-z-[2] tw-flex tw-w-full">
    </app-help-box>
  } -->
</div>

@if (pluginConfigService.isChatbotPluginEnabled()) {
  <app-chatbot></app-chatbot>
}
